import { berlinCalendarDate } from '@shared/berlin-time';
import { StatusChipAppearanceMap } from '@shared/chip';

/** Report keys of `POST /report/fis` (backend #5211). */
export enum FisReportKind {
  Controlling = 'Controlling',
  Absenz = 'Absenz',
  RueckstellungenPbh = 'RueckstellungenPbh',
  Stammdaten = 'Stammdaten',
  IstBesetzung = 'IstBesetzung',
}

/** Display order of the report kinds. */
export const FIS_REPORT_KINDS: readonly FisReportKind[] = [
  FisReportKind.Controlling,
  FisReportKind.Absenz,
  FisReportKind.RueckstellungenPbh,
  FisReportKind.Stammdaten,
  FisReportKind.IstBesetzung,
];

/** Status of a report run as the list shows it. */
export enum ReportTaskStatus {
  Running = 'running',
  Ready = 'ready',
  Failed = 'failed',
  /** Succeeded, but the file is gone (HTTP 410): only a restart helps. */
  Expired = 'expired',
}

export const REPORT_STATUS_CHIP_APPEARANCES: StatusChipAppearanceMap = {
  [ReportTaskStatus.Running]: 'primary',
  [ReportTaskStatus.Ready]: 'success',
  [ReportTaskStatus.Failed]: 'error',
  [ReportTaskStatus.Expired]: 'subtle',
};

/**
 * How often a pending run of this browser is checked against the list, like
 * the rollout polling: pushes alone can be missed (#5248).
 */
export const REPORT_POLL_INTERVAL_MS = 30_000;

/** Where the reports page lives; the notifications navigate there. */
export const REPORTS_ROUTE = '/mitarbeiter/search/reports';

/** `AsyncTaskInfoDto.type` of a report run. */
export const FIS_REPORT_TASK_TYPE = 'FIS_REPORTS';

/** Option value of the branch multiselect that stands for every visible branch. */
export const ALL_BRANCHES = '*';

/**
 * Days a finished file stays downloadable (backend #5211). The ticket text
 * says 2; the backend keeps 7. Clarification pending (#5248).
 */
export const REPORT_RETENTION_DAYS = 7;

/** Longest period the backend accepts, exactly 10 years included. */
export const MAX_PERIOD_YEARS = 10;

/** Earliest key date of the "Rückstellungen PBH" report. */
export const RUECKSTELLUNGEN_MIN_LAST_DAY = berlinCalendarDate(2023, 11, 31);

/** Most recent report runs the list shows. */
export const MAX_LISTED_REPORT_TASKS = 50;

/**
 * The backend keeps no request parameters at a run, so the app remembers them
 * per run in localStorage for the list text and the restart (#5248).
 */
export const REPORT_REQUESTS_STORAGE_KEY = 'hrp.fis-reports.requests';
export const MAX_STORED_REQUESTS = 50;
